import { Member, User } from "@sendbird/chat/lib/__definition";
import { Avatar } from "@arco-design/web-react";
import React from "react";

import { UserAvatar } from "../../../../components/UserAvatar/UserAvatar";

type Props = {
  user: User | Member | null;
  size: number;
  groupName?: string;
  displayName?: string;
  avatarUrlOverride?: string;
}

export function ConversationAvatar({ user, size, groupName, displayName, avatarUrlOverride }: Props) {
  if (groupName) {
    return <Avatar size={size}>{groupName.charAt(0).toUpperCase()}</Avatar>;
  }

  if (!user) {
    return <Avatar size={size}>?</Avatar>;
  }

  const label = (displayName || user.nickname || "").trim();
  const nameParts = label.split(/\s+/).filter(Boolean);

  return (
    <UserAvatar
      avatarUrl={avatarUrlOverride || (user as User).plainProfileUrl || (user as User).profileUrl || undefined}
      firstName={nameParts[0]}
      lastName={nameParts.length > 1 ? nameParts.slice(1).join(" ") : undefined}
      size={size}
      shape="circle"
      alt={label}
    />
  );
}